<section class="coupon-page">

  <header class="page-header">

    <div>
      <span class="eyebrow">
        Marketing e promoções
      </span>

      <h1>
        Cupons de desconto
      </h1>

      <p>
        Crie promoções para todo o cardápio
        ou para produtos específicos.
      </p>
    </div>

  </header>


  <div
    class="message error"
    *ngIf="error">

    {{ error }}

  </div>


  <div
    class="message success"
    *ngIf="success">

    {{ success }}

  </div>


  <!-- RESTAURANTE -->

  <section class="restaurant-selector">

    <div>

      <label>
        Restaurante
      </label>

      <select
        [(ngModel)]="restaurantId"
        (change)="onRestaurantChange()">

        <option
          *ngFor="
            let restaurant
            of restaurants
          "
          [ngValue]="restaurant.id">

          {{ restaurant.name }}

        </option>

      </select>

    </div>

  </section>


  <!-- FORM -->

  <section
    class="coupon-form-card"
    *ngIf="restaurantId">

    <header class="form-header">

      <div>

        <span class="eyebrow">

          {{
            editingCouponId
              ? 'Editar promoção'
              : 'Nova promoção'
          }}

        </span>

        <h2>

          {{
            editingCouponId
              ? 'Editar cupom'
              : 'Criar cupom'
          }}

        </h2>

      </div>

      <span class="form-icon">
        🎟️
      </span>

    </header>


    <div class="form-grid">


      <div class="field">

        <label>
          Código *
        </label>

        <input
          [(ngModel)]="form.code"
          maxlength="30"
          placeholder="Ex: BEMVINDO10">

        <small>
          O cliente digitará esse código
          no carrinho.
        </small>

      </div>


      <div class="field">

        <label>
          Nome da promoção
        </label>

        <input
          [(ngModel)]="form.name"
          placeholder="Ex: 10% de boas-vindas">

      </div>


      <div class="field full">

        <label>
          Descrição
        </label>

        <textarea
          [(ngModel)]="form.description"
          rows="3"
          placeholder="Explique brevemente a promoção">
        </textarea>

      </div>


      <!-- TIPO -->

      <div class="field">

        <label>
          Tipo de desconto *
        </label>

        <select
          [(ngModel)]="form.type">

          <option
            value="PERCENTAGE">

            Percentual (%)

          </option>

          <option
            value="FIXED">

            Valor fixo (R$)

          </option>

        </select>

      </div>


      <div class="field">

        <label>

          {{
            form.type === 'PERCENTAGE'
              ? 'Percentual de desconto *'
              : 'Valor do desconto *'
          }}

        </label>

        <div class="value-field">

          <span>

            {{
              form.type ===
                'PERCENTAGE'
                ? '%'
                : 'R$'
            }}

          </span>

          <input
            [(ngModel)]="form.value"
            type="number"
            min="0"
            step="0.01">

        </div>

      </div>


      <!-- ESCOPO -->

      <div class="field full">

        <label>
          Aplicar o cupom em
        </label>

        <div class="scope-options">

          <label
            class="scope-card"
            [class.selected]="
              form.scope === 'ALL'
            ">

            <input
              type="radio"
              name="couponScope"
              [(ngModel)]="form.scope"
              value="ALL">

            <span class="scope-icon">
              🍽️
            </span>

            <div>

              <strong>
                Todo o cardápio
              </strong>

              <small>
                O desconto considera todos
                os produtos do pedido.
              </small>

            </div>

          </label>


          <label
            class="scope-card"
            [class.selected]="
              form.scope === 'PRODUCTS'
            ">

            <input
              type="radio"
              name="couponScope"
              [(ngModel)]="form.scope"
              value="PRODUCTS">

            <span class="scope-icon">
              🍕
            </span>

            <div>

              <strong>
                Produtos específicos
              </strong>

              <small>
                Escolha quais produtos
                participam da promoção.
              </small>

            </div>

          </label>

        </div>

      </div>


      <!-- PRODUTOS -->

      <div
        class="field full"
        *ngIf="
          form.scope ===
          'PRODUCTS'
        ">

        <label>
          Produtos participantes *
        </label>

        <div class="product-selector">

          <label
            class="coupon-product"
            *ngFor="
              let product
              of products
            "
            [class.selected]="
              isProductSelected(
                product.id
              )
            ">

            <input
              type="checkbox"
              [checked]="
                isProductSelected(
                  product.id
                )
              "
              (change)="
                toggleProduct(
                  product.id
                )
              ">

            <img
              *ngIf="product.imageUrl"
              [src]="product.imageUrl"
              [alt]="product.name">

            <div
              class="product-placeholder"
              *ngIf="!product.imageUrl">

              🍽️

            </div>

            <div>

              <strong>
                {{ product.name }}
              </strong>

              <small>
                {{
                  formatMoney(
                    product.price
                  )
                }}
              </small>

            </div>

          </label>

        </div>

      </div>


      <!-- REGRAS -->

      <div class="field">

        <label>
          Pedido mínimo
        </label>

        <div class="value-field">

          <span>R$</span>

          <input
            [(ngModel)]="
              form.minimumOrder
            "
            type="number"
            min="0"
            step="0.01">

        </div>

      </div>


      <div class="field">

        <label>
          Desconto máximo
        </label>

        <div class="value-field">

          <span>R$</span>

          <input
            [(ngModel)]="
              form.maxDiscount
            "
            type="number"
            min="0"
            step="0.01">

        </div>

      </div>


      <div class="field">

        <label>
          Limite total de usos
        </label>

        <input
          [(ngModel)]="
            form.usageLimit
          "
          type="number"
          min="1"
          placeholder="Sem limite">

      </div>


      <div class="field">

        <label>
          Limite por cliente
        </label>

        <input
          [(ngModel)]="
            form.usagePerCustomer
          "
          type="number"
          min="1"
          placeholder="Sem limite">

      </div>


      <div class="field">

        <label>
          Início
        </label>

        <input
          [(ngModel)]="
            form.startsAt
          "
          type="datetime-local">

      </div>


      <div class="field">

        <label>
          Expiração
        </label>

        <input
          [(ngModel)]="
            form.expiresAt
          "
          type="datetime-local">

      </div>


      <label class="active-control">

        <input
          type="checkbox"
          [(ngModel)]="
            form.isActive
          ">

        <span>
          <strong>
            Cupom ativo
          </strong>

          <small>
            Disponível para utilização.
          </small>
        </span>

      </label>

    </div>


    <footer class="form-actions">

      <button
        *ngIf="editingCouponId"
        type="button"
        class="secondary-button"
        (click)="cancelEdit()">

        Cancelar

      </button>

      <button
        type="button"
        class="primary-button"
        [disabled]="saving"
        (click)="saveCoupon()">

        {{
          saving
            ? 'Salvando...'
            : editingCouponId
              ? 'Salvar alterações'
              : 'Criar cupom'
        }}

      </button>

    </footer>

  </section>


  <!-- LISTA -->

  <section
    class="coupon-list-section"
    *ngIf="restaurantId">

    <header>

      <div>

        <span class="eyebrow">
          Promoções cadastradas
        </span>

        <h2>
          Cupons
        </h2>

        <p>
          {{ coupons.length }}
          cupom(ns) encontrado(s)
        </p>

      </div>

    </header>


    <div
      class="loading-state"
      *ngIf="loading">

      Carregando cupons...

    </div>


    <div
      class="empty-state"
      *ngIf="
        !loading &&
        !coupons.length
      ">

      <span>
        🎟️
      </span>

      <h3>
        Nenhum cupom cadastrado
      </h3>

      <p>
        Crie sua primeira promoção
        no formulário acima.
      </p>

    </div>


    <div class="coupon-grid">

      <article
        class="coupon-card"
        *ngFor="
          let coupon
          of coupons
        "
        [class.inactive]="
          !coupon.isActive
        ">

        <div class="coupon-card-top">

          <div>

            <span class="coupon-code">
              {{ coupon.code }}
            </span>

            <h3>
              {{
                coupon.name ||
                getDiscountLabel(
                  coupon
                )
              }}
            </h3>

          </div>

          <span
            class="coupon-status"
            [class.inactive-status]="
              !coupon.isActive
            ">

            {{
              coupon.isActive
                ? 'Ativo'
                : 'Inativo'
            }}

          </span>

        </div>


        <strong class="discount-value">

          {{
            getDiscountLabel(
              coupon
            )
          }}

        </strong>


        <div class="coupon-scope">

          {{
            coupon.scope === 'ALL'
              ? '🍽️ Todo o cardápio'
              : '🍕 ' +
                coupon.products.length +
                ' produto(s)'
          }}

        </div>


        <div class="coupon-details">

          <div>

            <small>
              Pedido mínimo
            </small>

            <strong>

              {{
                coupon.minimumOrder
                  ? formatMoney(
                      coupon.minimumOrder
                    )
                  : 'Sem mínimo'
              }}

            </strong>

          </div>


          <div>

            <small>
              Utilizações
            </small>

            <strong>

              {{
                coupon.usedCount
              }}

              /

              {{
                coupon.usageLimit ||
                '∞'
              }}

            </strong>

          </div>

        </div>


        <div class="coupon-actions">

          <button
            type="button"
            class="edit-button"
            (click)="
              editCoupon(
                coupon
              )
            ">

            Editar

          </button>


          <button
            type="button"
            class="status-button"
            [disabled]="
              changingStatusCouponId ===
              coupon.id
            "
            (click)="
              toggleCoupon(
                coupon
              )
            ">

            {{
              changingStatusCouponId ===
                coupon.id
                ? 'Alterando...'
                : coupon.isActive
                  ? 'Inativar'
                  : 'Ativar'
            }}

          </button>


          <button
            type="button"
            class="delete-button"
            [disabled]="
              deletingCouponId ===
              coupon.id
            "
            (click)="
              deleteCoupon(
                coupon
              )
            ">

            {{
              deletingCouponId ===
                coupon.id
                ? 'Excluindo...'
                : 'Excluir'
            }}

          </button>

        </div>

      </article>

    </div>

  </section>

</section>